import { Services } from "../../services/Services.js";
import { resolveValue } from "../utils/ui-helpers.js";
import { Editor } from "./Editor.js";

export class CheckBox extends Editor {

    constructor(parent, options = {}) {

        options = Object.assign({
            label: '',
            value: false
        }, options || {});

        super(parent, options);

        const {
            label = null,
            autofocus = false,
        } = options;

        this.label = label;
        this.autofocus = autofocus;

        return this;

    };

    getLabel() { return resolveValue(this.label, this); };

    _render(vm) {

        const ct = Services.get('templates');

        var value = this.getValue(),
            css = this.getCss() || '',
            props = Object.assign({
                id: this.getId(),
                disabled: this.isDisabled() || this.isReadOnly(),
                onchange: (e) => {
                    var value = e.target.checked;
                    this.changeValue(value);
                },
                'data-focus': (!(this.isDisabled() || this.isReadOnly()) && this.isAutofocus()) ? 'auto' : null,
            }),
            options = {
                text: this.getLabel(),
                visible: this.isVisible(),
            };

        return ct.checkBox(value, css, props, options);

    };

}